/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable ngrx/no-store-subscription */
/* eslint-disable no-self-assign */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Store } from '@ngrx/store';
import { CjaTagService } from 'src/app/shared/services/cja-tag/cja-tag.service';
import { Observable, Subscription } from 'rxjs';
import * as fromSearch from '../../../features/search/+state';
import { Location, SelectedGeolocation } from '../../models/v2/search';
import { DirectionsService } from '../../services/directions/directions.service';
import { SearchUI } from './../../models/ui/searchui';
import { ActivatedRoute, Router } from '@angular/router';
import { last } from 'rxjs/operators';
import { MapInfoWindow } from '@angular/google-maps';
import { AppConstants } from 'src/app/core/models/app-constants';
import '../../../core/util/string-prototypes';
import { EnvironmentService } from '@commonspirit/ngx-environment';
import { EnvValue } from '@commonspirit/ngx-environment/lib/models/key-value-pair';

/**
 * Description placeholder
 * @date 8/27/2021 - 11:59:42 AM
 *
 * @export
 * @class GoogleMapComponent
 * @typedef {GoogleMapComponent}
 */
@Component({
  selector: 'fal-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss']
})
export class GoogleMapComponent implements OnInit {
  pi = Math.PI;
  markerClustererImagePath = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
  @ViewChild(GoogleMap) map!: GoogleMap;
  @Output() markerClick: EventEmitter<number> = new EventEmitter<number>();
  @Input()
  radiusDistance: number | null | undefined;
  showDialog = false;
  getSelectedGeolocationSubscription: Subscription;
  selectedGeolocation: SelectedGeolocation | null;
  radiusCal: number | 0 | null | undefined;
  scale: number | 0 | null | undefined;
  zoomVal: number | 0 | null | undefined;
  latitude2: number | 0 | null | undefined;
  longitude2: number | 0 | null | undefined;
  locationId: number | 0 | null | undefined;
  clusterDialog: boolean;
  mapPinDialog: boolean;
  mobileMax: number;
  tabletMax: number;
  enableBlockIT: boolean;
  public is24OpenTitle = 'Open 24/7';
  public innerWidth: any;
  mobileTabletView = false;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = event.target.innerWidth;
  }
  @Input()
  singleMapPin: string;
  @Input()
  public get locations(): Location[] | null {
    return this._locations;
  }

  @ViewChild(MapInfoWindow, { static: false }) infoWindow: google.maps.InfoWindow;
  markersLocation: any;
  @ViewChild('clusterDiv') myDiv: ElementRef;

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  public set locations(locations: Location[] | null) {
    if (!locations) return;
    this._locations = locations;
    this.markers = [];
    for (const loc of this._locations) {
      const marker = this.createMarker(loc);
      this.markers.push(marker);
    }

    if (this.radiusDistance == undefined) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams != undefined) {
        const distanceParam = urlParams.get('distance');
        if (distanceParam != null) this.radiusDistance = Number(distanceParam);
        else this.radiusDistance = 10;
      } else this.radiusDistance = 10;
    } else {
      this.radiusDistance = this.radiusDistance;
    }
    this.route.params.subscribe((params) => {
      this.locationId = params['id'] as number;
    });
    if (this.locationId) {
      const bounds = new google.maps.LatLngBounds();
      for (const marker of this.markers) {
        bounds.extend(marker.getPosition() as google.maps.LatLng);
      }
      this.searchUI$ = this.store.select(fromSearch.getCurrentUI);
    } else {
      if (sessionStorage.getItem('LocationZoom') != 'LocationZoom') {
        setTimeout(() => {
          this.setMapBounds();
        }, 1);
      } else {
        sessionStorage.setItem('LocationZoom', 'LocationZoom');
      }
    }
    const mapCenter = {
      lat: this._locations[0].address.latitude || 0,
      lng: this._locations[0].address.longitude || 0
    };
    this.store.dispatch(fromSearch.SearchActions.setMapCenter({ mapCenter }));
  }

  degrees_to_radians(degrees: number): number {
    return degrees * (this.pi / 180);
  }

  radians_to_degrees(radians: number): number {
    return radians * (180 / this.pi);
  }

  miles_to_kilometers(miles: number): number {
    const factor = 0.621371;
    return miles / factor;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getDistanceLatLng(bearing: number) {
    const R = 6378.1; //earth radius in kms
    const brng = Math.round((360 / 8) * bearing);
    const d = this.miles_to_kilometers(this.radiusDistance!);
    const latitude1 = this.selectedGeolocation?.latitude;
    const longitude1 = this.selectedGeolocation?.longitude;
    const lat1 = this.degrees_to_radians(Number(latitude1));
    const lon1 = this.degrees_to_radians(Number(longitude1));
    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d / R) + Math.cos(lat1) * Math.sin(d / R) * Math.cos(brng));
    const lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(d / R) * Math.cos(lat1), Math.cos(d / R) - Math.sin(lat1) * Math.sin(lat2));
    this.latitude2 = this.radians_to_degrees(lat2);
    this.longitude2 = this.radians_to_degrees(lon2);
  }

  private _locations: Location[] | null = [];
  location?: Location;
  locationDetailsLink: string;
  searchUI$: Observable<SearchUI> = new Observable<SearchUI>();
  color: string = globalThis.window.getComputedStyle(document.documentElement).getPropertyValue('--dhcl-color-primary');
  svg = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
  <svg
  width="26"
  height="32"
  viewBox="0 0 26 32"
  fill="none"
  version="1.1"
  id="svg73"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:svg="http://www.w3.org/2000/svg">
  <defs
  id="defs77" />
  <g
  id="g249">
  <path
  fill-rule="evenodd"
  clip-rule="evenodd"
  d="M0 12.9843C0 19.6932 8.47013 27.9606 11.7085 30.8768C12.4144 31.5123 13.484 31.5158 14.1935 30.8827C17.4377 27.9927 25.8948 19.8061 25.8948 12.9843C25.8948 5.8133 20.0981 0 12.9474 0C5.79679 0 0 5.8133 0 12.9843Z"
  fill="${this.color}"
  id="path69" />
  <path
  id="ellipse71"
  style="fill:#ffffff"
  d="M 17.72747,13.037 A 4.7272701,4.7407398 0 0 1 13.0002,17.77774 4.7272701,4.7407398 0 0 1 8.2729301,13.037 4.7272701,4.7407398 0 0 1 13.0002,8.2962599 4.7272701,4.7407398 0 0 1 17.72747,13.037 Z" />
  </g>
  </svg>`;
  markers: google.maps.Marker[] = [];
  smallDimensions = [2, 28, 28, 34];
  baseDimensions = [0, 32, 32, 38];
  scaledDimensions = [5, 37, 42, 48];

  setMarker(marker: google.maps.Marker, dims: number[]): void {
    marker?.setIcon({
      url: `data:image/svg+xml;charset=UTF-8;base64,` + btoa(this.svg),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(dims[0], dims[1]),
      scaledSize: new google.maps.Size(dims[2], dims[3])
    });
  }

  setMapBounds(): void {
    const bounds = new google.maps.LatLngBounds();
    const bearing = 8; // This value indicates 8 angles from center location
    const latitude1 = this.selectedGeolocation?.latitude;
    const longitude1 = this.selectedGeolocation?.longitude;
    if (this.markers.length > 1 && this.radiusDistance! > 5) {
      for (const marker of this.markers) {
        bounds.extend(marker.getPosition() as google.maps.LatLng);
      }
      this.map.googleMap!.fitBounds(bounds);
    } else {
      for (let i = 0; i < bearing; i++) {
        this.getDistanceLatLng(i);
        const marker = this.createRadiusMarker();
        bounds.extend(marker.getPosition() as google.maps.LatLng);
      }
      this.map.googleMap!.fitBounds(bounds);
    }
  }

  getMarkerByLatLng(latLng: google.maps.LatLng): google.maps.Marker | undefined {
    return this.markers.find((x) => JSON.stringify(x.getPosition()?.toJSON()) == JSON.stringify(latLng.toJSON()));
  }

  setMarkerBig(event: google.maps.MapMouseEvent): void {
    const marker = this.getMarkerByLatLng(event.latLng);
    if (!marker) return;
    this.setMarker(marker, this.scaledDimensions);
  }

  setMarkerNormal(event: google.maps.MapMouseEvent): void {
    const marker = this.getMarkerByLatLng(event.latLng);
    if (!marker) return;
    this.setMarker(marker, this.baseDimensions);
  }

  setMarkerSmall(event: google.maps.MapMouseEvent): void {
    const marker = this.getMarkerByLatLng(event.latLng);
    if (!marker) return;
    this.setMarker(marker, this.smallDimensions);
  }

  onMapDrag(): void {
    const mapCenter = { lat: this.map.googleMap!.getCenter().lat(), lng: this.map.googleMap!.getCenter().lng() };
    this.store.dispatch(fromSearch.SearchActions.setMapCenter({ mapCenter }));
  }

  onMapZoomChanged(): void {
    const mapZoom = this.map.googleMap!.getZoom();
    this.store.dispatch(fromSearch.SearchActions.setMapZoom({ mapZoom }));
  }

  createMarker(loc: Location): google.maps.Marker {
    return new google.maps.Marker({
      position: { lat: loc.address.latitude!, lng: loc.address.longitude! },
      draggable: false,
      zIndex: 10,
      optimized: false,
      icon: {
        url: `data:image/svg+xml;charset=UTF-8;base64,` + btoa(this.svg),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(this.baseDimensions[0], this.baseDimensions[1]),
        scaledSize: new google.maps.Size(this.baseDimensions[2], this.baseDimensions[3])
      },
      title: loc.name
    });
  }

  createRadiusMarker(): google.maps.Marker {
    return new google.maps.Marker({
      position: { lat: this.latitude2!, lng: this.longitude2! },
      draggable: false,
      zIndex: 10,
      optimized: false,
      icon: {
        url: `data:image/svg+xml;charset=UTF-8;base64,` + btoa(this.svg),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(this.baseDimensions[0], this.baseDimensions[1]),
        scaledSize: new google.maps.Size(this.baseDimensions[2], this.baseDimensions[3])
      }
    });
  }

  /**
   * Description placeholder
   * @date 8/27/2021 - 8:40:47 PM
   *
   * @type {string}
   */
  // Will move this to env library when testing is complete.
  mapOptions: google.maps.MapOptions = { disableDefaultUI: true, gestureHandling: 'cooperative' };

  /**
   * Description placeholder
   * @date 8/27/2021 - 11:59:42 AM
   *
   * @type {Observable<boolean>}
   */
  apiLoaded: Observable<boolean> | undefined;
  /**
   * Creates an instance of GoogleMapComponent.
   * @date 8/27/2021 - 11:59:42 AM
   *
   * @constructor
   */

  constructor(
    private directionsService: DirectionsService,
    private store: Store,
    private route: ActivatedRoute,
    public router: Router,
    private cjaTagService: CjaTagService,
    public environmentService: EnvironmentService
  ) {
    const enableBlockITForEnvironment: EnvValue | undefined = this.environmentService.getSetting('enableBlockIT')?.value;
    if (typeof enableBlockITForEnvironment === 'boolean') {
      this.enableBlockIT = enableBlockITForEnvironment;
    }
  }

  ngOnInit(): void {
    this.mobileMax = AppConstants.mobileMax;
    this.tabletMax = AppConstants.tabletMax;
    this.innerWidth = window.innerWidth;
    this.apiLoaded = this.store.select(fromSearch.getApiLoaded);
    this.store
      .select(fromSearch.getCurrentUI)
      .pipe(last())
      .subscribe(() => {
        this.searchUI$;
      });

    this.getSelectedGeolocationSubscription = this.store.select(fromSearch.getSelectedGeolocation).subscribe((selectedGeolocation) => {
      this.selectedGeolocation = selectedGeolocation;
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setMobileTabletView() {
    if (this.innerWidth <= this.tabletMax) this.mobileTabletView = true;
    else this.mobileTabletView = false;
  }

  onMarkerClick(index: number, event: google.maps.Marker, title: string) {
    this.setMobileTabletView();
    //if (this.mobileTabletView) {
    this.clusterDialog = false;
    this.mapPinDialog = true;
    this.location = this._locations?.find((loc) => loc.name === title);
    if (this.location) {
      if (this.enableBlockIT) {
        this.locationDetailsLink = `/${this.location.slug}`;
      } else {
        this.locationDetailsLink = `/${this.location.name
          .toUrlFriendly()
          .stripPeriod()
          .condenseDashes()
          .removeSpecialCharacters()
          .sanitizeHyphens()}-${this.location.id}`;
      }
    }
    this.showDialog = false;
    this.markersLocation = event.getPosition();
    const position1 = new google.maps.LatLng(Number(event.getPosition()?.lat()), Number(event.getPosition()?.lng()));

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const marker: google.maps.Marker = this.markersLocation[0] as google.maps.Marker;
    this.setTimeFunction(position1, marker);
    //}
    // else {
    //   this.markerClick.emit(index);
    //   if (!this.locations) return;
    //   const address = this.locations[index]?.address;
    //   if (this.singleMapPin == 'singleMapPin') {
    //     window.open(this.directionsService.getDirectionsUrl(address.addressLine1, address.city, address.state, address.zipCode));
    //   }
    // }
  }

  setTimeFunction(position1: google.maps.LatLng, marker: google.maps.Marker) {
    const infoWindow = new google.maps.InfoWindow({ content: '' });
    setTimeout(() => {
      infoWindow.setPosition(position1);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      infoWindow.setContent(this.myDiv.nativeElement.innerHTML);
      google.maps.event.addListener(infoWindow, 'domready', () => {
        const el = document.querySelectorAll('.markerslist');
        el.forEach((x) =>
          x?.addEventListener('click', () => {
            // emit location to allow for result card "selection"
            this.emitLocationSelection(x.id);
            const indexOfLocation = this.locations?.findIndex((l) => l.name === x.id) as number;
            const markerOfLocation = this.markers.find((m) => m.getTitle() === x.id);
            if (indexOfLocation !== -1 && markerOfLocation) {
              // close cluster info window
              infoWindow.close();
              // show location details info window
              this.onMarkerClick(indexOfLocation, markerOfLocation, x.id);
            }
          })
        );
        const locationDetailLinks = document.querySelectorAll('a[fal-location-detail-link]');
        const addressDetails = document.querySelector('div.address-details');
        addressDetails?.addEventListener('click', () => this.getDirection());
        locationDetailLinks.forEach((x) => x?.addEventListener('click', () => void this.goToLocationDetails()));
      });
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      infoWindow.open(this.map.googleMap, marker);
    }, 100);
  }

  onMarkerClusterWindow(event: Cluster, _element: any) {
    this.showDialog = false;
    this.clusterDialog = true;
    this.mapPinDialog = false;
    this.markersLocation = event.getMarkers();
    const position1 = new google.maps.LatLng(event.getCenter().lat(), event.getCenter().lng());
    const marker: google.maps.Marker = this.markersLocation[0] as google.maps.Marker;
    this.setTimeFunction(position1, marker);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getTitle(marker: google.maps.Marker): string {
    return marker.getTitle()!;
  }

  emitLocationSelection(locationName: string): void {
    this.markerClick.emit(this.locations?.findIndex((x) => x.name === locationName));
  }

  async goToLocationDetails(): Promise<boolean> {
    if (this.location) {
      // sessionStorage.setItem('LocationZoom', 'LocationZoom');
      // sessionStorage.setItem(SessionConstants.SelectedLocation, JSON.stringify(this.location));
      // // eslint-disable-next-line ngrx/avoid-dispatching-multiple-actions-sequentially
      // this.store.dispatch(fromLocations.LocationActions.setProvidersBySelectedLocation({ providers: this.location.associatedProviders }));
      // // eslint-disable-next-line ngrx/avoid-dispatching-multiple-actions-sequentially
      // this.store.dispatch(fromLocations.LocationActions.setSelectedLocation({ payload: this.location }));

      this.cjaTagService.logCJAEvent({
        event: 'customEvent',
        event_name: 'find_location:location detail:click',
        event_category: 'find a location',
        event_action: 'location detail',
        event_label: 'click',
        event_facility: this.location.name, // name of the facility if available
        patientEngagement: 'true',
        visitor_loginStatus: ''
      });

      return await this.router.navigate([this.locationDetailsLink]);
    }

    return false;
  }
  getDirection(): void {
    const address = this.location?.address;
    if (!address || !address.addressLine1 || !address.city || !address.state || !address.zipCode) return;
    const url = this.directionsService.getDirectionsUrl(address.addressLine1, address.city, address.state, address.zipCode);
    window.open(url, '_blank')?.focus();
    this.cjaTagService.logCJAEvent({
      event: 'customEvent',
      event_name: 'find_location:get directions',
      event_category: 'find a location',
      event_action: 'get directions',
      event_label: 'click',
      'link.URL': url, // URL of the href for the direction link
      patientEngagement: 'true',
      visitor_loginStatus: 'false' // true or false based on if the user is logged in
    });
  }
}
